// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopSidebar_root__pNY_X"};